import * as React from 'react';
import { Button, Popup } from 'semantic-ui-react';

import { EstadoCurso } from '../../estadoCurso';

export interface Props {
    idCurso: number;
    nombre: string;
    sala: string;
    inscritos: string;
    color: string;
    estado: EstadoCurso;
    sinCupo?: boolean;
    mensajeSiDesactivado?: string;
    mePresionaron?(props: Props): void;
}

const CursoBoton: React.FunctionComponent<Props> = props => {
    const {
        estado,
        sinCupo = false,
        mePresionaron,
        nombre,
        sala,
        inscritos,
        color,
        mensajeSiDesactivado,
    } = props;

    const estiloCapacidadPorFefecto = { marginLeft: '0.2em' };
    const estiloSinCupo =
        sinCupo && estado !== EstadoCurso.Trabajando
            ? { color: 'red', ...estiloCapacidadPorFefecto }
            : { ...estiloCapacidadPorFefecto };

    const estiloBotonPorDefecto: React.CSSProperties = {
        backgroundColor: color,
        padding: '4px',
        width: '6em',
    };
    const estiloBoton: React.CSSProperties =
        estado === EstadoCurso.Inscrito
            ? {
                  ...estiloBotonPorDefecto,
                  padding: '2px',
                  border: '2px solid',
                  boxShadow: '0 0 20px 5px #222',
                  position: 'relative',
              }
            : estiloBotonPorDefecto;

    const componente = (
        <div style={{ display: 'inline-block' }}>
            <Button
                style={estiloBoton}
                size='mini'
                disabled={estado === EstadoCurso.NoInscribible}
                loading={estado === EstadoCurso.Trabajando}
                active={estado === EstadoCurso.Inscrito}
                onClick={() => {
                    if (mePresionaron) {
                        mePresionaron(props);
                    }
                }}
            >
                {nombre}
                <br />
                S:{sala}&nbsp;<span style={estiloSinCupo}>{inscritos}</span>
            </Button>
        </div>
    );

    return mensajeSiDesactivado ? (
        <Popup content={mensajeSiDesactivado} trigger={componente} hideOnScroll inverted />
    ) : (
        componente
    );
};

interface State {
    estado: EstadoCurso;
}

class Curso extends React.Component<Props, State> {
    public state: State = {
        estado: this.props.estado,
    };

    public componentWillReceiveProps(nextProps: Props) {
        this.setState({ estado: nextProps.estado });
    }

    public render() {
        const { estado: _, mePresionaron, ...resto } = this.props;

        return (
            <CursoBoton
                {...resto}
                mePresionaron={idCurso => {
                    this.setState({ estado: EstadoCurso.Trabajando });
                    if (mePresionaron) {
                        mePresionaron(idCurso);
                    }
                }}
                estado={this.state.estado}
            />
        );
    }
}

export default Curso;



// WEBPACK FOOTER //
// ./src/modulos/Horarios/TomaDeHorarios/componentes/Inscribir/Cursos/componentes/TablaDeCursos/Curso.tsx